var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173328",
    "data-name": "Group 173328",
    transform: "translate(-0.12 -0.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 43,
    cy: 43,
    r: 43,
    transform: "translate(0.12 0.12)",
    fill: "#db0c04"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_7b4c0cac5f362e809d3faebe20283a7e",
    "data-name": "7b4c0cac5f362e809d3faebe20283a7e",
    transform: "translate(21.889 21.889)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    "data-name": "Line 396",
    x2: 42.463,
    y2: 42.463,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    y1: 42.463,
    x2: 42.463,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.02866d2a9c2a0be208e2720303b77272.svg";
export { ForwardRef as ReactComponent };